import React from 'react';
// scss
import './Pagination.scss';

const Pagination = ({totalPages, currentPage, setNewPage, setNewLimit }) => {
  const buttonsLimit = 7;
  const buttonsArr = getPaginationButtons( totalPages, buttonsLimit, currentPage );

  return (
    <div className="pagination">
      <p className="pagination__text">Показувати</p>
      <select className="pagination__select" onChange={e => setNewLimit(e.target.value)} >
        <option>10</option>
        <option>15</option>
        <option>20</option>
        <option>30</option>
        <option>40</option>
        <option>50</option>
        <option>100</option>
      </select>
      <ul className="pagination__list">
        {buttonsArr?.map((i, idx) => { if (!i) return ( <li key={idx} className="pagination__item"> ... </li> );
          else return (
              <li key={idx} className="pagination__item">
                <button className={`pagination__btn ${ i === currentPage ? 'current' : '' }`} type="button" onClick={() => setNewPage(i)} > {i} </button>
              </li>
            );
        })}
      </ul>
    </div>
  );
};

export default Pagination;

function getPaginationButtons(totalPages, buttonsLimit, currentPage) {
  if (totalPages <= buttonsLimit) {
    // Якщо загальна кількість сторінок менша або дорівнює ліміту, повертаємо масив від 1 до totalPages
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const buttons = [1]; // Починаємо з 1
  const halfLimit = Math.floor((buttonsLimit - 4) / 2); // -4 для елементів [1, null, ..., null, totalPages]

  let start = Math.max(2, currentPage - halfLimit);
  let end = Math.min(totalPages - 1, currentPage + halfLimit);

  // Коригуємо межі, якщо не вистачає кнопок для заповнення buttonsLimit
  if (end - start + 1 < buttonsLimit - 4) {
    if (currentPage <= halfLimit + 2) {
      end = Math.min(totalPages - 1, start + buttonsLimit - 5);
    } else {
      start = Math.max(2, end - (buttonsLimit - 5));
    }
  }

  // Додаємо `null` для розриву після першої кнопки, якщо це не початок
  if (start > 2) {
    buttons.push(null);
  }

  // Додаємо проміжні кнопки
  for (let i = start; i <= end; i++) {
    buttons.push(i);
  }

  // Додаємо `null` для розриву перед останньою кнопкою, якщо це не кінець
  if (end < totalPages - 1) {
    buttons.push(null);
  }

  // Додаємо totalPages як останню кнопку
  buttons.push(totalPages);

  return buttons;
}
